import  { useState } from 'react';
import thepillIcon from '../../../assets/images/pill-coinIcon.png';
import tetherIcon from '../../../assets/images/tether-coinIcon.png';
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import Loader from '../../Loader/buttonLoad';
import { useToast } from '../../../hook/usetoast';
import { queryClient } from '../../../config';
import { useGetPillPrice } from '../../modals/api/api';
import PropTypes from 'prop-types';
import { formatBalance } from '../../../hook/bigNumber';
import { Footer } from '../../../components/footer';
import { useStakeDetails } from '../stakingwallet/api';
import { useNavigate } from 'react-router-dom';
import { generateSecureRandomNumber } from '../../../hook/randomString';
import { useSwapToMasterWallet } from '../redeem/api';
import RoyaltySwapHistory from './SwapHistory';


const RoyaltySwapTab = () => {
    const [isLoading, setIsLoading] = useState(false)
    const { data: stakeBalance, isFetching } = useStakeDetails()
    const navigate = useNavigate()
    const [pillFeeAmount, setPillFeeAmount] = useState()
    const toast = useToast()
    const swapToMasterWallet = useSwapToMasterWallet()



    const validationSchema = yup.object().shape({
        amount: yup
            .number()
            .typeError('Pill amount is required')
            .moreThan(0, 'Amount must be greater than 0')
            .max(999999, 'Maxmimum amount is 999999')
            .test('sufficient-balance', 'Amount must be less than or equal royalty wallet balance', function (value) {
                return value <= formatBalance(stakeBalance?.data?.royaltyWallet);
            })
            .required('Pill amount is required'),
    })

    const defaultValues = {
        amount: '',
        toAmount: 0
    };

    const { data: pillPrice } = useGetPillPrice()


    const { control, handleSubmit, formState: { errors, isDirty, isValid }, watch, setValue, getValues, reset } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(validationSchema),
    });

    const handleInputChange = async (event) => {
        const value = event?.target?.value
        if (value) {

            let pillValue = value * pillPrice?.data?.royaltySwapFee / 100

            setPillFeeAmount(pillValue)
            let usdtCalculation = value - pillValue
            let toValue = (usdtCalculation / pillPrice?.data?.Pillprice)
            toValue = formatBalance(toValue)
            setValue('toAmount', toValue)
        } else {
            setValue('toAmount', 0)
        }
    };

    const [randomData, setRandomData] = useState(Math.floor(100000 + generateSecureRandomNumber() * 900000))


    const watchAmount = watch('amount')

    const onSubmit = async (data) => {

        const feeData = {
            amount: data?.amount,
            toAmount: data?.toAmount,
            fee: pillPrice?.data?.royaltySwapFee,
            pillFeeAmount: pillFeeAmount,
            randomID: randomData,
            walletName: "Royalty-Wallet"

        }


        try {

            setIsLoading(true)

            const stakeResponse = await swapToMasterWallet.mutateAsync(feeData)
            if (stakeResponse?.status) {
                setIsLoading(false)
                queryClient.refetchQueries("stake-balance")
                queryClient.refetchQueries("move-to-stake-history")
                toast.success(stakeResponse?.message)
                setRandomData(Math.floor(100000 + generateSecureRandomNumber() * 900000))
                reset()
            } else {
                setIsLoading(false)
                toast?.error(stakeResponse?.message)
            }



        } catch (error) {

            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }


    return (
        <div>
            <div className="mainContent">
                {(isFetching || isLoading) && <Loader />}
                <div className="pageContent def-py-30">

                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/royalty-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Swap</span>
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="tabcnt">

                                        <div className='row justify-content-center mb-5'>
                                            <div className="col-lg-5 col-md-8">
                                                <div className="px-4">
                                                    <div className="swapTitle text-center mb-4">
                                                        Swap
                                                    </div>
                                                    <div className='swapcard'>
                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                            <button className='btn btnEmpty d-flex g-8 align-items-center'>
                                                                <img src={thepillIcon} alt='thepillIcon' className='img-w29' />
                                                                <span className='fs-16 fw-400'>PILL</span>
                                                            </button>
                                                            <span className='reward tplreward text-end ms-2'>
                                                                TPL Balance: {
                                                                    (stakeBalance?.data?.royaltyWallet)?.toString().includes('.')
                                                                        ? parseFloat(stakeBalance?.data?.royaltyWallet)
                                                                            ?.toFixed(4)
                                                                            .replace(/(\.0+)?$/, '')
                                                                        : stakeBalance?.data?.royaltyWallet
                                                                }
                                                            </span>
                                                        </div>

                                                        <div className='form-group mb-0 swapInput'>
                                                            <div className="input-group">
                                                                <Controller
                                                                    name="amount"
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <input
                                                                            {...field}
                                                                            type="text"
                                                                            className="form-control h-auto"
                                                                            placeholder="Enter Amount"
                                                                            autoComplete="off"
                                                                            inputMode="decimal"
                                                                            step="0.01"
                                                                            onWheel={(e) => e.target.blur()}
                                                                            onChange={e => {
                                                                                const value = e.target.value;
                                                                                const regex = /^\d*(\.\d{0,5})?$/;
                                                                                if (regex.test(value) || value === "") {
                                                                                    field.onChange(value);
                                                                                }
                                                                            }}
                                                                            maxLength={(getValues('amount')?.toString()?.includes('.')) ? 7 : 6}
                                                                            onInput={(e) => handleInputChange(e)}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                                                                    e.preventDefault();
                                                                                }
                                                                            }}
                                                                        />
                                                                    )}
                                                                />
                                                             
                                                                <div className="input-group-append">
                                                                    <div className="input-group-text">
                                                                        TPL
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {errors.amount && <p style={{ marginTop: '8px' }} className="errMsg">* {errors.amount.message}</p>}
                                                    <div className="text-center" style={{ margin: "-20px 0px" }}>
                                                        <button className='btn btnSwapArrow'>
                                                            <img src={require('../../../assets/images/arrowDownIcon.svg').default} alt='arrowDownIcon' />
                                                        </button>
                                                    </div>
                                                    <div className='swapcard'>
                                                        <div>
                                                            <button className='btn btnEmpty d-flex g-8 align-items-center'>
                                                                <img src={tetherIcon} alt='tethericon' className='img-w29' />
                                                                <span className='fs-16 fw-400'>Tether</span>
                                                            </button>
                                                        </div>
                                                        <div className='form-group mb-0 swapInput'>
                                                            <div className="input-group">
                                                                <Controller
                                                                    name="toAmount"
                                                                    control={control}
                                                                    defaultValue={parseFloat(getValues('toAmount')) || 0}
                                                                    render={({ field }) => (
                                                                        <input
                                                                            {...field}
                                                                            type="number"
                                                                            className='form-control h-auto'
                                                                            id="toAmount"
                                                                            inputMode="decimal"
                                                                            placeholder="0"
                                                                            disabled
                                                                        />



                                                                    )}
                                                                />
                                                                <div className="input-group-append">
                                                                    <div className="input-group-text">
                                                                        USDT
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <p className='reward'>Swap Fee: {pillPrice?.data?.royaltySwapFee} % TPL</p>

                                                    <div className="mt-4 text-center mb-3">
                                                        <div><button className='btn btn-primary px-4 px-lg-5' onClick={handleSubmit(onSubmit)} disabled={(!isDirty || !isValid) || watchAmount <= 0 || sessionStorage.getItem('role') === 'adminView'}>Submit</button></div>


                                                        <div className='fs-14 fw-100 text-white-60 mt-2'>Amount Add to Master wallet</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='px-4 card2Head'>Swap History</div>
                                        <RoyaltySwapHistory />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>

    )
}
RoyaltySwapTab.propTypes = {
    stakeBalance: PropTypes.shape({
        data: PropTypes.shape({
            redeemWalletAvailable: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
};
export default RoyaltySwapTab;